import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { IBusinessProfileStore } from '../interfaces/business-profile-store.interface';

export const selectBusinessProfileStore = (state: IAppState) =>
  state.businessProfile;

export const selectBusinessType = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    businessType: businessProfileStore.businessType,
  })
);

export const selectBusinessIndustry = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    businessIndustry: businessProfileStore.businessIndustry,
  })
);

export const selectBusinessDescription = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    businessDescription: businessProfileStore.businessDescription,
  })
);

export const selectCustomerTypes = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    customerTypes: businessProfileStore.customerTypes,
  })
);

export const selectSupportMethods = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    supportMethods: businessProfileStore.supportMethods,
  })
);

export const selectStateOfOrg = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    stateOfOrg: businessProfileStore.stateOfOrg,
  })
);

export const selectDba = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    dba: businessProfileStore.dba,
  })
);

export const selectCompanyAddress = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    companyAddress: businessProfileStore.companyAddress,
  })
);

export const selectAnnualRevenue = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    annualRevenue: businessProfileStore.annualRevenue,
  })
);

export const selectCompanyWebsite = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    companyWebsite: businessProfileStore.companyWebsite,
  })
);

export const selectYearFounded = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    yearFounded: businessProfileStore.yearFounded,
  })
);

export const selectEmployeeCount = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    employeeCount: businessProfileStore.employeeCount,
  })
);

export const selectInvoicingMethod = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    invoicingMethod: businessProfileStore.invoicingMethod,
  })
);

export const selectSupportMethod = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    supportMethods: businessProfileStore.supportMethods,
  })
);

export const selectCompanySearch = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    companySearch: businessProfileStore.companySearch,
  })
);

export const selectAllBusinessProfile = createSelector(
  selectBusinessProfileStore,
  (businessProfileStore: IBusinessProfileStore) => ({
    businessType: businessProfileStore.businessType,
    businessIndustry: businessProfileStore.businessIndustry,
    businessDescription: businessProfileStore.businessDescription,
    customerTypes: businessProfileStore.customerTypes,
    stateOfOrg: businessProfileStore.stateOfOrg,
    dba: businessProfileStore.dba,
    companyAddress: businessProfileStore.companyAddress,
    annualRevenue: businessProfileStore.annualRevenue,
    companyWebsite: businessProfileStore.companyWebsite,
    yearFounded: businessProfileStore.yearFounded,
    employeeCount: businessProfileStore.employeeCount,
    invoicingMethod: businessProfileStore.invoicingMethod,
    supportMethods: businessProfileStore.supportMethods,
  })
);
